<template>
  <div
    class="c-theFooter js-the-footer"
    :class="{ 'c-theFooter-business': isBusinessFooter }"
  >
    <footer
      class="c-footer"
      ref="footer"
    >
      <div
        class="c-footer_inner"
        v-if="!isSimpleFooter"
      >
        <div class="c-footerGuide">
          <ul class="c-footerGuideList">
            <li
              class="c-footerGuideList_list"
              :class="`c-footerGuideList_list-${footerContent.name}`"
              v-for="(footerContent, index) in footerContents"
              :key="`footer_${index}_${footerContent.name}`"
            >
              <template v-if="!isSP">
                <div
                  class="c-footerGuideList_contentHeader"
                  :class="`c-footerGuideList_contentHeader-${footerContent.class}`"
                >
                  {{ footerContent.text }}
                </div>
                <GuideSublist
                  :footer-content="footerContent"
                  :is-logged-in="isLoggedIn"
                  :is-business-footer="isBusinessFooter"
                />
              </template>
              <CollapseGuideSublist
                v-else
                :footer-content="footerContent"
                :is-logged-in="isLoggedIn"
                :is-business-footer="isBusinessFooter"
              />
            </li>
          </ul>
        </div>
        <div class="c-footerInfo">
          <div class="c-footerInfoApp">
            <div class="c-footerInfoApp_app c-footerInfoApp_app-ios">
              <a
                :href="$util.genAppUrl(appStoreUrl, $ua.isFromPc(), true)"
                target="_blank"
              >
                <img
                  src="@/assets/images/common/banner_ios_s.png"
                  alt="Download on the App Store"
                  loading="lazy"
                  decoding="async"
                >
              </a>
            </div>
            <div class="c-footerInfoApp_app c-footerInfoApp_app-android">
              <a
                :href="$util.genAppUrl(appStoreUrl, $ua.isFromPc(), false)"
                target="_blank"
              >
                <img
                  src="@/assets/images/common/banner_android_s.png"
                  alt="Android App on Google play"
                  loading="lazy"
                  decoding="async"
                >
              </a>
            </div>
          </div>
          <div class="c-footerInfoInquiry">
            <div class="c-footerInfoInquiry_inner">
              <div class="c-footerInfoInquiry_title">
                カスタマーサポート
              </div>
              <div class="c-footerInfoInquiry_subtitle">
                返信が必要な場合はこちら
              </div>
              <div class="c-footerInfoInquiry_button">
                <compoment
                  :is="isBusinessFooter ? 'DButton' : 'CButtonV2'"
                  :href="addQueryToUrlIfBusinessPreview($coconala.url('/inquiry'))"
                  class="c-inquiryButton"
                  :color="isBusinessFooter ? 'primary' : 'thirdly'"
                  :type="isBusinessFooter ? 'outlined' : ''"
                  :size="isBusinessFooter ? 'medium' : 'm'"
                  width="200px"
                  :is-bold="true"
                >
                  お問い合わせ
                </compoment>
              </div>
            </div>
          </div>
          <GoikenBox :is-business="isBusinessFooter" />
          <div class="c-footerInfo_feedback"></div>
        </div>
      </div>
      <div
        class="c-footer_bottom"
        :class="{ 'c-footer_bottom-simple': isSimpleFooter }"
      >
        <div
          class="c-footer_bottomInner"
          :class="{ 'c-footer_bottomInner-simple': isSimpleFooter }"
        >
          <div
            class="c-footer_terms"
            :style="styles"
            v-if="!isSimpleFooter"
          >
            <div class="c-footer_snsIcon">
              <a
                class="c-footer_termsLink c-footer_termsLink-sns"
                href="https://twitter.com/coconala"
                target="_blank"
                rel="noopener"
              >
                <CoconalaIcon
                  size="20px"
                  name="twitter"
                />
              </a>
              <a
                class="c-footer_termsLink c-footer_termsLink-sns"
                href="https://www.facebook.com/coconalajp"
                target="_blank"
                rel="noopener"
              >
                <CoconalaIcon
                  size="20px"
                  name="facebook-brands"
                />
              </a>
              <a
                class="c-footer_termsLink c-footer_termsLink-sns"
                href="https://www.instagram.com/coconala_official"
                target="_blank"
                rel="noopener"
              >
                <CoconalaIcon
                  size="19px"
                  name="instagram"
                />
              </a>
              <a
                class="c-footer_termsLink c-footer_termsLink-youtube"
                href="https://www.youtube.com/channel/UCMUoDRN3g4pZ5KyDuLrr1ag"
                target="_blank"
                rel="noopener"
              >
                <CoconalaIcon
                  size="26px"
                  name="youtube"
                />
              </a>
            </div>
            <div class="c-footer_termsList">
              <a
                class="c-footer_termsLink"
                href="/pages/terms_user"
              >
                利用規約
              </a>
              <a
                class="c-footer_termsLink"
                href="/pages/privacy"
              >
                プライバシーポリシー
              </a>
              <a
                class="c-footer_termsLink"
                href="/pages/tokushou"
              >
                特定商取引法に基づく表記
              </a>
              <a
                class="c-footer_termsLink"
                href="/pages/terms_provider"
              >
                加盟店規約
              </a>
              <a
                class="c-footer_termsLink"
                href="/pages/terms_exchange_point"
              >
                有償ポイントに関する特約
              </a>
              <a
                class="c-footer_termsLink"
                href="/pages/settlement"
              >
                資金決済法に基づく表記
              </a>
            </div>
          </div>
          <div class="c-copyright">
            <span>&copy; 2012-{{ $util.dayjs().get('year') }} coconala Inc.</span>
            <img
              v-if="isBusinessFooter && !isSimpleFooter"
              src="@/assets/images/pages/business/logo-footer.svg"
              alt="coconala business"
              class="c-copyrightLogo"
              loading="lazy"
              decoding="async"
            >
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

import FooterContents from './data/footer.json'
import businessMixin from '~/mixins/pages/business-mixin'

// シンプルフッターにするページ（needsPerfectMatch:trueなら完全一致、falseなら前方一致）
const SIMPLE_FOOTER_PATHS = [
  { path: '/requests/add', needsPerfectMatch: false },
  { path: '/customize/requests/add/', needsPerfectMatch: false },
  { path: '/business/', needsPerfectMatch: true },
  { path: '/business/login', needsPerfectMatch: false }
]

export default {
  name: 'TheFooter',
  components: {
    CollapseGuideSublist: () =>
      import('./components/CollapseGuideSublist' /* webpackChunkName: "CollapseGuideSublist" */),
    GuideSublist: () => import('./components/GuideSublist' /* webpackChunkName: "GuideSublist" */),
    DButton: () => import('~/components/atoms/DS2/DButton' /* webpackChunkName: "DButton" */),
    GoikenBox: () => import('~/components/organisms/GoikenBox' /* webpackChunkName: "GoikenBox" */)
  },
  mixins: [businessMixin],
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC', 'isSP', 'isTB']),
    ...mapState('ui', ['footerBottomTb', 'footerBottomSp']),
    ...mapState('auth', ['appStoreUrl']),
    ...mapState('auth/user', ['isBusiness']),
    ...mapState('master', ['masterCategories']),
    ...mapState('constants', ['VIRTUAL_CATEGORY']),
    paddingBottom() {
      if (this.isSP) {
        return this.footerBottomSp
      }
      if (this.isTB) {
        return this.footerBottomTb
      }
      return ''
    },
    styles() {
      return {
        'padding-bottom': this.paddingBottom
      }
    },
    footerContents() {
      if (this.isBusinessFooter) {
        return [...FooterContents]
      }
      const categoryList = this.masterCategories.map(masterCategory => {
        return {
          id: masterCategory.id,
          text: masterCategory.name,
          url: `/categories/${masterCategory.id}`,
          url_type: 'coconala'
        }
      })
      // カテゴリ一覧はマスタに情報がないので手動で作成
      categoryList.push({
        text: 'サイトマップ',
        url: '/categories/',
        url_type: 'coconala'
      })
      const categoryContents = {
        name: 'categories',
        text: 'カテゴリ',
        class: 'caption',
        type: 'list',
        sub: this.extendChildCategory(categoryList)
      }

      return [...FooterContents, categoryContents]
    },
    isSimpleFooter() {
      return SIMPLE_FOOTER_PATHS.some(
        pathObject =>
          pathObject.needsPerfectMatch
            ? window.location.pathname === pathObject.path
            : window.location.pathname.startsWith(pathObject.path)
      )
    },
    isBusinessFooter() {
      return (
        !!this.$route.query.is_business ||
        this.isBusiness ||
        ['business-top', 'business'].includes(this.$route.name)
      )
    }
  },
  methods: {
    extendChildCategory(categoryList) {
      const divinationPhone = this.VIRTUAL_CATEGORY.DIVINATION_PHONE
      // 拡張したいカテゴリを定義
      const exChildCategories = [
        {
          // 途中挿入したい親カテゴリID
          parentCategoryId: divinationPhone.CONDITION.CATEGORY_ID,
          data: {
            // IDはなんでもいい
            id: `${divinationPhone.CONDITION.CATEGORY_ID}-${
              divinationPhone.CONDITION.SERVICE_CLASS
            }`,
            text: divinationPhone.NAME,
            url: `/categories/${divinationPhone.CONDITION.CATEGORY_ID}?service_kind=${
              divinationPhone.CONDITION.SERVICE_CLASS
            }`,
            url_type: 'coconala'
          }
        }
      ]

      const returnCategory = []
      categoryList.forEach(c => {
        returnCategory.push(c)
        const childCategories = exChildCategories.filter(e => c.id === e.parentCategoryId)
        if (childCategories.length > 0) {
          returnCategory.push(...childCategories.map(childCategory => childCategory.data))
        }
      })
      return returnCategory
    }
  }
}
</script>
<style lang="scss" scoped>
.c-theFooter {
  z-index: z(footer);
  margin-top: 60px;
  color: $color-white;
  body.-withoutFooterMargin & {
    margin-top: 0;
  }

  // ファイル外からクラスを付与している
  &-withoutMarginTop {
    margin-top: 0;
  }
  &-withoutMarginTopOnBlogSearchSP {
    @media (max-width: breakpoint(SearchBlogs, M)) {
      margin-top: 0;
    }
  }
  &-withoutMarginTopOnMypageBlog {
    @media (max-width: breakpoint(Mypage, L)) {
      margin-top: 0;
    }
  }
  // ビジネス定義
  &.c-theFooter-business {
    .c-footer {
      background: $ds2-color-business-navy-1000;
      &_termsLink {
        color: $ds2-color-gray-25;
      }
      &_inner {
        padding: 40px 32px 32px;
        width: 1280px;
      }
      &_bottom {
        padding: 32px 0 40px;
        background-color: transparent;
        &-simple {
          padding: 8px 0;
          background-color: $ds2-color-business-navy-1000;
          .c-copyright {
            background-color: $ds2-color-business-navy-1000;
            font-size: 14px;
          }
        }
      }
      &_bottomInner {
        align-items: flex-end;
        &-simple {
          display: flex;
          height: 26px;

          align-items: center;
        }
      }
      .c-footerGuideList {
        display: grid;
        letter-spacing: 0.05em;

        font-feature-settings: 'palt';
        gap: 48px;
        grid-template-areas: 'services users help info';
        grid-template-columns: 126px 130px 116px 160px;
        grid-template-rows: 1fr;
        &_contentHeader {
          margin-bottom: 12px;
          color: $ds2-color-gray-25;
          font-weight: bold;
          font-size: 15px;
        }
      }
      /deep/ .c-footerGuideSublist {
        &_list {
          a {
            @include link-effect;

            color: $ds2-color-gray-25;
          }
        }
      }
    }
    .c-footerInfo {
      flex-basis: 331px;
    }
    .c-footerInfoInquiry {
      background: $ds2-color-gray-25;

      &_inner {
        color: $ds2-color-gray-900;
      }

      &_subtitle {
        color: $ds2-color-gray-600;
      }
    }
    .c-footerGuide {
      flex-basis: 835px;
    }
    /deep/ .c-goikenBox {
      background: $ds2-color-gray-25;

      &_inner {
        color: $ds2-color-gray-900;
      }
    }

    .c-goikenBoxContent {
      border: 1px solid $ds2-color-gray-200;
    }
    .c-copyright {
      padding: 0;
      width: auto;
      background-color: transparent;
      color: $ds2-color-gray-25;
    }
    .c-copyrightLogo {
      margin-left: 32px;
    }
  }
}

.c-footer {
  width: 100%;
  height: auto;
  background: $color-gray-800;

  &_inner {
    position: relative;
    display: flex;
    margin: auto;
    padding: 40px 12px 32px;
    width: 1280px;
    height: auto;
    font-size: 12px;

    justify-content: space-between;
  }

  &_bottom {
    padding: 42px 0 30px;
    background-color: #363634;
    &-simple {
      padding: 16px 0;
    }
  }
  &_bottomInner {
    display: flex;
    margin: 0 auto;
    padding: 0 32px;
    max-width: 1280px;
    height: 28px;

    align-items: flex-end;
    justify-content: space-between;

    &-simple {
      height: auto;

      align-items: center;
      justify-content: center;
      .c-copyright {
        padding-top: 0;

        align-items: center;
        justify-content: center;
      }
    }
  }
  &_terms {
    display: grid;
    align-self: flex-end;
    line-height: 1;
    grid-template-areas:
      'snsIcons'
      'terms';
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    &-snsIcons {
      grid-area: snsIcons;
    }
    &-terms {
      grid-area: terms;
    }
  }
  &_snsIcon {
    display: flex;
    margin-right: 20px;
    font-size: 20px;

    align-items: baseline;
  }
  &_termsList {
    display: flex;

    flex-wrap: wrap;
    justify-content: flex-start;
  }
  &_termsLink {
    @include link-effect;

    margin-right: 1em;
    padding-top: 12px;
    color: $color-gray-200;
    font-size: 12px;
    &-sns {
      margin-right: 24px;
    }
    &-youtube {
      width: 26px;
      height: 20px;
    }
  }
}

.c-footerCollapse {
  // 依存関係ありのためBlockをネスト
  .c-footerGuideList {
    &_contentHeader {
      color: $color-white;
    }
  }
}

.c-footerGuide {
  padding-right: 0;
  border-right: 1px solid $ds2-color-gray-700;

  flex-basis: 890px;
}

.c-footerGuideList {
  display: grid;

  gap: 0 20px;
  grid-template-areas: 'services users help info categories';
  grid-template-columns: 140px 140px 140px 160px 240px;
  grid-template-rows: 1fr;
  &_contentHeader {
    margin-bottom: 12px;
    font-weight: bold;
    font-size: 15px;
  }
  &_list {
    // NOTE: JSONで取得するkeyをmodifierに設定している
    &-services {
      grid-area: services;
    }
    &-for_users {
      grid-area: users;
    }
    &-help_guide {
      grid-area: help;
    }
    &-info_coconala {
      grid-area: info;
    }
    &-categories {
      grid-area: categories;
    }
  }
}

/deep/ .c-footerGuideSublist {
  &_list {
    margin-bottom: 8px;
    a {
      @include link-effect;

      display: inline-block;
      color: $ds2-color-white;
    }
  }
}

/deep/ .c-footerVision {
  font-size: 12px;

  &_caption {
    margin-bottom: 4px;
    font-weight: bold;
  }
}

.c-footerInfo {
  flex-basis: 280px;
}

.c-footerInfoApp {
  display: flex;
  padding: 0 0 24px;

  &_app {
    flex-basis: 50%;
    &:first-child {
      margin-right: 27px;
    }

    &-ios {
      text-align: right;
    }

    &-android {
      text-align: left;
    }

    a {
      display: inline-block;
    }
  }
}

.c-footerInfoInquiry {
  border-radius: 4px;
  background: $color-beige-50;
  font-size: 13px;

  &_inner {
    padding: 12px 0 16px;
    color: $color-gray-800;
    text-align: center;
  }

  &_title {
    letter-spacing: 0.05em;
    font-weight: bold;
    font-size: 15px;
  }

  &_subtitle {
    margin-bottom: 8px;
    letter-spacing: 0.05em;
    font-size: 12px;
  }
}

.c-copyright {
  display: flex;
  padding-top: 12px;
  width: auto;
  background-color: #363634;
  text-align: center;
  font-size: 11px;
  line-height: 1;

  align-items: flex-end;
  justify-content: flex-end;
}

.c-copyrightLogo {
  display: block;
  width: 191px;
}

@media (max-width: breakpoint(Requests, M)) {
  .c-footer {
    &_bottom {
      padding: 0;
      background-color: transparent;
      &-simple {
        padding: 0;
      }
    }
    &_bottomInner {
      display: block;
      margin-top: 0;
      margin-bottom: 0;
      padding: 0;
      height: auto;
      &-simple {
        height: auto;

        align-items: center;
        justify-content: center;
        .c-copyright {
          align-items: center;
          justify-content: center;
        }
      }
    }
    &_terms {
      margin: 0 auto;
      padding: 0 0 28px;
      max-width: 437px;

      flex-wrap: wrap;
      justify-content: flex-start;
    }
    &_snsIcon {
      margin: 0 auto;
    }
    &_termsList {
      display: flex;

      flex-wrap: wrap;
      justify-content: flex-start;
    }
    &_termsLink {
      display: inline-block;
      margin-bottom: 12px;
      padding-top: 0;
      color: $color-gray-300;
      font-size: 12px;
      line-height: 1.5;
    }
  }
  .c-copyright {
    padding: 4px 0;
    width: auto;

    justify-content: center;
  }
  .c-theFooter {
    &.c-theFooter-business {
      .c-footer {
        &_bottomInner {
          min-width: auto;
          height: auto;
          &-simple {
            height: 26px;
          }
        }
        &_terms {
          grid-template-areas:
            'snsIcons'
            'terms';
          grid-template-columns: 1fr;
          gap: 0;
          &-snsIcons {
            grid-area: snsIcons;
          }
          &-terms {
            grid-area: terms;
          }
        }
        &_termsList {
          display: flex;

          flex-wrap: wrap;
          justify-content: flex-start;
        }
        &_bottom {
          padding: 0;
          &-simple {
            padding: 8px 0;
          }
        }
      }
      .c-copyright {
        display: flex;
        padding: 0 0 20px 0;

        align-items: flex-end;
      }
      .c-copyrightLogo {
        margin: 0 0 0 34px;
      }
    }

    /deep/ .c-footerGuideSublist {
      &_list {
        margin-bottom: 0;
      }
    }
  }
}

@media (min-width: breakpoint(Requests, S)) and (max-width: breakpoint(Requests, M)) {
  .c-footer {
    &_inner {
      flex-direction: column;
      padding: 25px 20px 40px;
      width: 100%;
    }
    &_termsList {
      justify-content: center;
    }
  }

  .c-footerGuide {
    margin-right: 0;
    margin-bottom: 28px;
    padding-right: 0;
    padding-bottom: 60px;
    border-right: none;
    border-bottom: 1px solid $color-white;

    flex-basis: 100%;
  }
  .c-footerGuideList {
    gap: 34px 20px;
    -ms-grid-columns: 1fr 20px 1fr 20px 1fr;
    grid-gap: 34px 20px;
    -ms-grid-rows: auto 34px 1fr;
    grid-template-areas:
      'services help categories'
      'users info categories';
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto 1fr;
  }

  /deep/ .c-footerGuideSublist {
    &_list {
      a {
        padding: 4px 0;
      }
    }
  }

  .c-footerInfo {
    flex-basis: 100%;
  }

  .c-footerInfoApp {
    margin: 0 auto;
    padding: 0 0 24px;
    max-width: 330px;
    width: calc(100% - 48px);
  }

  .c-footerInfoInquiry {
    margin: 0 auto;
    max-width: 330px;
    width: calc(100% - 48px);
  }

  .c-copyright {
    margin-top: 20px;
  }

  // ビジネス用
  .c-theFooter {
    &.c-theFooter-business {
      .c-footer {
        &_inner {
          padding: 40px 48px;
          width: 100%;
        }
        &_bottomInner {
          &-simple {
            .c-copyright {
              margin-top: 0;
              padding: 0;
            }
          }
        }
        .c-footerGuideList {
          gap: 20px;
          -ms-grid-columns: 1fr 1fr 1fr 1fr;
          grid-gap: 20px;
          -ms-grid-rows: auto 34px 1fr;
          grid-template-areas: 'services users help info';
          grid-template-columns: 1fr 1fr 1fr 1fr;
          grid-template-rows: auto;
        }
      }
      .c-footerGuide {
        padding-bottom: 32px;
        border-bottom: 1px solid $ds2-color-gray-700;

        flex-basis: 100%;
      }
      .c-copyright {
        margin-top: 20px;
        padding: 0 0 40px;
      }
    }
  }
}

@media (max-width: breakpoint(Requests, S)) {
  .c-theFooter {
    margin-top: 0;
    &.c-theFooter-business {
      .c-footer {
        &_inner {
          padding: 0;
          width: 100%;
        }
        &_bottomInner {
          padding: 0 10px;
          min-width: auto;
          &-simple {
            height: 20px;
            .c-copyright {
              padding: 0;
              font-size: 13px;
            }
          }
        }
        &_termsList {
          justify-content: center;
        }
        &_bottom {
          &-simple {
            padding: 12px 0;
          }
        }
        .c-footerGuideList {
          gap: 0;
          grid-template-areas:
            'services'
            'users'
            'help'
            'info';
          grid-template-columns: 1fr;
          grid-template-rows: 1fr;
        }
        /deep/ .c-collapseGuideSublist {
          &_contentHeader {
            border-bottom: 1px solid $ds2-color-gray-700;
            color: $ds2-color-gray-25;
          }
        }
        /deep/ .c-footerGuideSublist {
          &_list {
            border-bottom: 1px solid $ds2-color-gray-700;
            font-size: 14px;
          }
        }
      }
      .c-footerInfo {
        flex-basis: 100%;
      }
      .c-footerGuide {
        flex-basis: 100%;
      }
      .c-copyright {
        flex-direction: column-reverse;
        padding: 0 0 20px 0;

        align-items: center;
      }
      .c-copyrightLogo {
        margin: 0 auto 12px;
      }
    }
  }

  .c-footer {
    &_inner {
      flex-direction: column;
      padding: 0;
      width: 100%;
    }
    &_terms {
      padding: 40px 0;

      justify-content: center;
    }
    &_bottom {
      &-simple {
        padding-top: 0;
      }
    }
    &_snsIcon {
      line-height: 1;
    }
    &_termsList {
      justify-content: center;
    }
    &_termsLink {
      margin: 0 6px 12px;
      font-size: 11px;
      line-height: 1.63;
      &-sns,
      &-youtube {
        margin: 0 12px 24px;
      }
    }
  }

  .c-footerGuide {
    margin-right: 0;
    padding: 0 0 48px;
    border-right: none;

    flex-basis: 100%;
  }

  .c-footerInfo {
    flex-basis: 100%;
  }

  .c-footerInfoApp {
    margin: 0 auto;
    padding: 0 0 24px;
    max-width: 330px;
    width: calc(100% - 48px);

    &_app {
      &:first-child {
        margin-right: 7%;
      }
    }
  }

  .c-footerInfoInquiry {
    margin: 0 auto;
    max-width: 330px;
    width: calc(100% - 48px);
  }

  .c-footerGuideList {
    gap: 0;
    grid-template-areas:
      'services'
      'users'
      'help'
      'info'
      'categories';
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }
}
</style>
